<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import InvoicePreview from '../../InvoicePreview/index.vue';
export default {
	components: {
		InvoicePreview
	},
	props: {},
	watch: {},
	data() {
		return {
			//搜索框
			searchlist: getdata().searchlist,
			overlength: 0,

			//加载
			count: 3,
			loading: false,
			//预览发票
			HuanqInvoicePreview: false
		};
	},
	computed: {
		noMore() {
			return this.count >= 20;
		},
		disabled() {
			return this.loading || this.noMore;
		}
	},
	mounted() {},
	created() {},
	methods: {
		//预览发票回调
		closediagInvoicePreview(e) {
			this.HuanqInvoicePreview = false;
		},
		//加载
		load() {
			this.loading = true;
			setTimeout(() => {
				this.count += 2;
				this.loading = false;
			}, 2000);
		},

		//搜索框高返回
		geOoverLength(e) {
			this.overlength = e;
		},
		//选择
		OptionNoteclick() {
			this.$emit('OptionNoteclick', 2);
		},
		//查询
		submitSearch(e) {
			console.log(e);
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
